import { WINTYPE } from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ASWinData,
    ActionSpinOptions,
    ActionSpinSound,
    PromoPanelGameConfiguration,
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import { Helper } from "@nolimitcity/promo-panel/bin/utils/Helper";

import { EventsManager } from "../../abstracts/events/EventsManager";
import { AbstractGameMode } from "../../abstracts/flow/AbstractGameMode";
import { BackgroundNames, WinType } from "../../abstracts/types/enums";
import { playSound } from "../../abstracts/utils/SoundUtils";
import { Apocalypse } from "../Apocalypse";
import { ApocalypseSoundNames } from "../assetsLoader/ApocalypseAssetsNames";
import { REMOVE_FAKE_SCATTERS } from "../events/ApocalypseEvents";
import { ApocalypseGameData } from "../types/ApocalypseInterfaces";
import { getWinLevel } from "./ApocalypseConfig";

export class ApocalypsePromoPanelConfig implements PromoPanelGameConfiguration {
    constructor() {}

    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: `Apocalypse`,
            hasActionSpin: true,
            graphics: { backgroundTextureName: BackgroundNames.NORMAL },
            getParsedData: (
                response: ApocalypseGameData,
                bet: number,
                prevResponse: ApocalypseGameData
            ): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: this.getSpinWin(response, prevResponse),
                    isBigWin: this.isBigWin(response),
                    winType: this.isMultiplierMode(response) ? WINTYPE.MULTIPLIER : WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.brokeTheBank,
                };
                return parsedData;
            },
        };
    }

    private isMultiplierMode(response: ApocalypseGameData): boolean {
        return (
            response.mode === AbstractGameMode.FREESPIN ||
            response.mode === AbstractGameMode.SUPER_FREESPIN ||
            response.mode === AbstractGameMode.FREESPIN_BETTER
        );
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            // play sound
            playSound({ name: ApocalypseSoundNames.AS_WIN });
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            // play sound
            playSound({ name: ApocalypseSoundNames.AS_BIG_WIN });
        }
    }

    private isBigWin(response: ApocalypseGameData): boolean {
        let win = response.thisSpinWinning;

        if (response.wasFeatureBuy || Apocalypse.model.isSXNBet) {
            const betPrice = Apocalypse.model.getBetPrice(); //TODO needs AS fix
            let winRatio: number = Math.round((win / betPrice) * 10000) / 10000;

            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals(win / response.playedBetValue, 2);
        const winLevel = getWinLevel(winRatio);

        return winLevel.winType === WinType.BIG || winLevel.winType === WinType.MAX_CAP;
    }

    private getSpinWin(response: ApocalypseGameData, prevRespons: ApocalypseGameData): number {
        let spinWinValue: number = +response.totalSpinWinnings;

        if (
            response.mode === AbstractGameMode.FREESPIN ||
            response.mode === AbstractGameMode.SUPER_FREESPIN ||
            response.mode === AbstractGameMode.FREESPIN_BETTER
        ) {
            spinWinValue = +response.totalFSWinning - +prevRespons.totalFSWinning;
        }

        return spinWinValue;
    }

    private isFreeSpinTriggered(response: ApocalypseGameData): boolean {
        if (response.nextMode !== response.mode) {
            EventsManager.trigger(REMOVE_FAKE_SCATTERS);
        }
        return (
            response.mode === AbstractGameMode.NORMAL &&
            (response.nextMode === AbstractGameMode.FREESPIN ||
                response.nextMode === AbstractGameMode.SUPER_FREESPIN ||
                response.nextMode === AbstractGameMode.FREESPIN_BETTER)
        );
    }

    private getFeatureName(response: ApocalypseGameData): string {
        if (
            response.mode == AbstractGameMode.FREESPIN ||
            response.nextMode == AbstractGameMode.FREESPIN
        ) {
            return `CARNAGE SPINS`;
        } else if (
            response.mode == AbstractGameMode.SUPER_FREESPIN ||
            response.nextMode == AbstractGameMode.SUPER_FREESPIN
        ) {
            return `DOOMSDAY SPINS`;
        } else if (
            response.mode == AbstractGameMode.FREESPIN_BETTER ||
            response.nextMode == AbstractGameMode.FREESPIN_BETTER
        ) {
            return `CATACLYSM SPINS`;
        }
        return response.mode;
    }

    private isRoundComplete(response: ApocalypseGameData): boolean {
        return (
            [
                AbstractGameMode.FREESPIN,
                AbstractGameMode.SUPER_FREESPIN,
                AbstractGameMode.FREESPIN_BETTER,
                AbstractGameMode.NORMAL,
            ].indexOf(response.nextMode) > -1
        );
    }

    private isBonusEnd(response: ApocalypseGameData): boolean {
        return (
            response.nextMode === AbstractGameMode.NORMAL &&
            (response.mode === AbstractGameMode.FREESPIN ||
                response.mode === AbstractGameMode.FREESPIN_SUPER ||
                response.mode === AbstractGameMode.FREESPIN_BETTER)
        );
    }
}
